import type * as React from 'react';
import { get } from '@Domain/Api';
import ssoModesFetched, {
	type SsoModesFetchedAction,
	type SsoModesFetchedPayload,
} from '@Application/Security/Sso/Actions/ssoModesFetched';
import ssoModesFetchFailed, {
	type SsoModesFetchFailedAction,
} from '@Application/Security/Sso/Actions/ssoModesFetchFailed';
import type FetchSsoModes from '@Application/Security/Sso/Queries/FetchSsoModes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = SsoModesFetchedAction | SsoModesFetchFailedAction;

export default (_query: FetchSsoModes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SsoModesFetchedPayload>(`${parameters.api.host}/api/enums/sso-modes`);

			const action = ssoModesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = ssoModesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
